import { Component, OnDestroy, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  isLoginError: boolean = false;
  loginMsg: string = "";
  loginProcessInitiated: boolean = true;
  loginService_: any;
  display: boolean = false;
  googleauthuri: SafeResourceUrl;
  assessmentid: number;
  moduleid: number;
  batchid: number;
  rootAdmin: string;
  //courseprogressdetails: any;

  constructor(private loginService: UseraccessserviceService, private router: Router, private activatedroute: ActivatedRoute, private util: UtilService,
    private modulemanager: ModulemanagementService, private schoolmanager: SchoolmanagementService, private headerservice: ComponentheaderService,private sanitizer: DomSanitizer) {
      this.googleauthuri = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.ImpataAppDomainUrl}/googleauth`); // source of iframe
      this.loginService_ = loginService;
  }
  
  updateLoadScreen(val: boolean) {
    this.loginService.isLoading = val;
  }

  async OnSubmit(email: string, password: string) {

    this.updateLoadScreen(true);
    this.isLoginError = false;
    
    try{    
      this.updateLoadScreen(true);

        const data: any = await this.loginService.userAuthentitcation(email, password, this.rootAdmin == '1').toPromise();
        this.loginService.setAuthenticatedUserToken(data.token);

        // redirect to dashboard, if no registered course... redirect to schoolhome
        // this.courseprogressdetails = await this.modulemanager.getCourseprogressDetails().toPromise();

        if (this.activatedroute.snapshot.queryParams.url) {
          this.router.navigateByUrl(this.activatedroute.snapshot.queryParams.url);
        }
        else if(data.firstTime){
          window.location.href = '/user/schoolhome';
        }
          else if(this.assessmentid > 0 && this.moduleid > 0){
          window.location.href = '/user/studentassesment?aid=' + this.assessmentid + '&classid=' + this.moduleid + '&batchid=' + this.batchid + '&target=1';
        }
        else{
          window.location.href = '/';
        }        

        this.updateLoadScreen(false);
    }
    catch(err){
      console.log(err)
        this.isLoginError = true;
        //  if(err.status === 400){
        //     this.loginService.setloginErrorMessage("Incorrect login details");
        //     console.log(this.loginService.getloginErrorMessage())
        //   }
        this.updateLoadScreen(false);
    }
  }

  async ngOnInit() {
    this.headerservice.setPageTitle('Login');
    window.addEventListener('message', this.receiveCredMessage.bind(this), false);
    this.activatedroute.queryParams.subscribe(params => {
      let myQueryParam = params['redirect'];
      if (myQueryParam === "studentassesment"){
        this.assessmentid = params["aid"];
        this.moduleid = params["classid"];
        this.batchid = params["batchid"];
      }
    });
    this.rootAdmin = this.activatedroute.snapshot.queryParams.rootadmin;
    const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain();
    if (schoolinfo.loginURL) {
      //this.router.navigateByUrl(schoolinfo.loginURL);
      window.location.href = schoolinfo.loginURL;
    }
    else {
      this.display = true;
    }
  }  

  async receiveCredMessage(event: MessageEvent){
    if (event.origin !== `${environment.ImpataAppDomainUrl}` && event.data.type !== 'GoogleCredentials') {
      return;
    }    
    if (event.data.payload){
      try {
        this.loginService.userGoogleAuthentication(event.data.payload).subscribe(
          (data) => {
            this.navigateAfterGoogleAuth(data['token'], data['email']);
          }
        );               
      } catch (error) {
        console.error("Request failed:", error);
      }  
    }
  }

  navigateAfterGoogleAuth(token: string, email: string){
    try {
      this.loginService.updateUserPrivateSchool(email).toPromise();
      const returnUrlString = this.activatedroute.snapshot.queryParams.url ? this.activatedroute.snapshot.queryParams.url : '';
      window.location.href = `/?token=${token}&url=${encodeURIComponent(returnUrlString)}`; 
    } catch (error) {
      console.error("Request failed:", error);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.receiveCredMessage);
  }
}
